import { render } from "./CreateRowdy.vue?vue&type=template&id=62da42cb&scoped=true"
import script from "./CreateRowdy.vue?vue&type=script&lang=js"
export * from "./CreateRowdy.vue?vue&type=script&lang=js"

import "./CreateRowdy.vue?vue&type=style&index=0&id=62da42cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62da42cb"]])

export default __exports__